import {formatSize, getSvgSize} from "../../../../utils/files/SvgSizeHelper";
import {Box, Button, Stack, Typography} from "@mui/material";
import {downloadSvg} from "../../../../utils/files/DownloadHelper";
import DownloadIcon from '@mui/icons-material/Download';

const Output = ({
                    svg
                }) => {
    const svgSize = getSvgSize(svg);

    return svg
        ? <Box>
            <Stack spacing={2} direct ion="column">
                <Button
                    onClick={() => downloadSvg(svg, "Awesome SVG")}
                    endIcon={<DownloadIcon/>}
                >
                    Make SVG
                </Button>

                <Typography
                    variant="body2"
                    fontWeight="bold"
                    color={
                        svgSize > 1024 * 1024
                            ? 'error'
                            : 'textPrimary'
                    }
                >
                    Size: {formatSize(svgSize)}
                </Typography>
            </Stack>
        </Box>
        : null;
}

export default Output;